import Const from 'constants';

let LineupsQuantity = {
    setLineupsQuantityFromStorage(value) {
        return {
            type: Const.SET_LINEUPS_QUANTITY,
            value,
        };
    },

    setLineupsQuantity(value, params = {}) {
        return (dispatch) => {
            const {saveToStorage = true, isResetAllowed = true} = params;

            dispatch({
                type: Const.SET_LINEUPS_QUANTITY,
                value,
                isResetAllowed,
            });

            if (saveToStorage) {
                dispatch(
                    this.saveDataToStorage('lineupsQuantity', function (state) {
                        const {lineupsQuantity} = state;
                        return lineupsQuantity.getLineupsQuantity();
                    }),
                );
            }
        };
    },
};

export default LineupsQuantity;
